import { __extends } from "tslib";
import ElementRangeState from './range-state';
/**
 * @ignore
 * 区域选中的 Action
 */

var ElementRangeSelected =
/** @class */
function (_super) {
  __extends(ElementRangeSelected, _super);

  function ElementRangeSelected() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.stateName = 'selected';
    return _this;
  }
  /**
   * 选中
   */


  ElementRangeSelected.prototype.selected = function () {
    this.setState();
  };

  return ElementRangeSelected;
}(ElementRangeState);

export default ElementRangeSelected;